import ReactGA from 'react-ga4'
import config from 'config'
import { getToggles } from 'quick-quote/feature-toggles'

const analyticsFn = () => {
  const isProd = getToggles().OC_ENVIRONMENT === 'prod'
  const initialiseGA = (trackingID, options = {}) => {
    ReactGA.initialize(trackingID, {
      ...options,
      gaOptions: {
        ...(options.gaOptions || {}),
        debug_mode: !isProd,
      },
      gtagOptions: {
        ...(options.gtagOptions || {}),
        debug_mode: !isProd,
      },
    })
    ReactGA.set({
      appName: config.appName,
      appVersion: config.appVersion,
    })
  }

  const logPageView = (location) => {
    if (!getToggles().ENABLE_REMOVE_POLICY_NO_GA4 || location.includes('middleware')) return
    ReactGA.set({ page: location })
    ReactGA.send({ hitType: 'pageview', page: location })
  }

  const sendCustomEvent = (args) => {
    ReactGA.event(args)
  }

  const sendGGAEvent = (featureName, action, extra = {}) => {
    const isDebugMode = getToggles().OC_ENVIRONMENT !== 'prod'
    const eventObj = {
      eventName: action,
      ...extra,
    }

    if (window.cordova) {
      if (window.GAAnalytics) {
        window.GAAnalytics.logEvent(
          featureName,
          eventObj,
          function(ok) {
            console.log('ok', ok)
          },
          function(err) {
            console.log('err', err)
          }
        )
      }
      return
    }

    ReactGA.event(featureName, {
      ...eventObj,
      ...(isDebugMode ? { debug_mode: true } : {}),
    })
  }

  return {
    initialiseGA,
    logPageView,
    sendCustomEvent,
    sendGGAEvent,
  }
}

export const analytics = analyticsFn()
